(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kassandra-cookie-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-kassandra-cookie-consent]');
    if (!root) return;

    const storageKey = 'kassandra_cookie_consent_v1';
    const preferencesPanel = root.querySelector('[data-kassandra-cookie-preferences]');
    const hasStoredConsent = () => {
      try {
        return window.localStorage.getItem(storageKey) !== null;
      } catch (error) {
        return false;
      }
    };

    const storeConsent = (value) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(value));
      } catch (error) {
        return;
      }
    };

    const hideBanner = () => {
      root.hidden = true;
    };

    const loadCustomerPrivacy = (callback) => {
      if (window.Shopify?.customerPrivacy) {
        callback(window.Shopify.customerPrivacy);
        return;
      }

      if (!window.Shopify?.loadFeatures) {
        callback(null);
        return;
      }

      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        (error) => {
          callback(error ? null : window.Shopify.customerPrivacy);
        }
      );
    };

    const setConsent = (consent) => {
      storeConsent(consent);
      loadCustomerPrivacy((customerPrivacy) => {
        if (!customerPrivacy?.setTrackingConsent) {
          hideBanner();
          return;
        }

        customerPrivacy.setTrackingConsent(consent, () => {
          hideBanner();
        });
      });
    };

    root.addEventListener('click', (event) => {
      const action = event.target.closest('[data-cookie-action]')?.dataset.cookieAction;
      if (!action) return;

      if (action === 'manage') {
        if (preferencesPanel.hidden) {
          preferencesPanel.hidden = false;
          event.target.textContent = 'Salva preferenze';
          return;
        }

        setConsent({
          preferences: root.querySelector('[data-consent-preferences]')?.checked ?? false,
          analytics: root.querySelector('[data-consent-analytics]')?.checked ?? false,
          marketing: root.querySelector('[data-consent-marketing]')?.checked ?? false,
          sale_of_data: false,
        });
        return;
      }

      if (action === 'accept') {
        setConsent({
          preferences: true,
          analytics: true,
          marketing: true,
          sale_of_data: true,
        });
        return;
      }

      if (action === 'decline') {
        setConsent({
          preferences: false,
          analytics: false,
          marketing: false,
          sale_of_data: false,
        });
      }
    });

    if (!hasStoredConsent()) {
      root.hidden = false;
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kassandra-signup-discount"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-kassandra-signup-discount]');
    if (!root) return;

    const storageKey = 'kassandra_signup_discount_closed_v1';
    const closeButton = root.querySelector('[data-signup-discount-close]');

    const hasClosed = () => {
      try {
        return window.localStorage.getItem(storageKey) === 'true';
      } catch (error) {
        return false;
      }
    };

    const markClosed = () => {
      try {
        window.localStorage.setItem(storageKey, 'true');
      } catch (error) {
        return;
      }
    };

    const hide = () => {
      markClosed();
      root.hidden = true;
    };

    const show = () => {
      if (hasClosed()) return;
      root.hidden = false;
      root.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    };

    const showWhenCookieBannerIsDone = () => {
      const cookieBanner = document.querySelector('[data-kassandra-cookie-consent]');
      if (!cookieBanner || cookieBanner.hidden) {
        show();
        return;
      }

      const observer = new MutationObserver(() => {
        if (cookieBanner.hidden) {
          observer.disconnect();
          window.setTimeout(show, 700);
        }
      });

      observer.observe(cookieBanner, { attributes: true, attributeFilter: ['hidden'] });
    };

    closeButton?.addEventListener('click', hide);

    root.addEventListener('click', (event) => {
      if (event.target === root) {
        hide();
      }
    });

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) {
        hide();
      }
    });

    root.querySelector('form')?.addEventListener('submit', () => {
      markClosed();
    });

    if (root.querySelector('.kassandra-signup-discount__success')) {
      root.hidden = false;
      return;
    }

    window.setTimeout(showWhenCookieBannerIsDone, 1400);
  })();
  } catch(e) { console.error(e); }
})();

})();
